// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"5b2be30c","297":"d18fa05e","643":"53b2888a","787":"e0d1cbe3","959":"7446b0b6"}[chunkId] + ".chunk.js";
};